import IraUserInfo from 'screens/IraUsers/IraUserInfo/IraUserInfo';

const ReroutingToIraUserDetails = (): JSX.Element => <IraUserInfo />;

export default ReroutingToIraUserDetails;
